import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Chip, ChipVariant } from "shared/ui/chip/Chip"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "../styles/_portal-news-list-item.scss"

interface PortalNewsListItemProps extends WithClassName {
  title: React.ReactNode
  portalVersion: React.ReactNode
  category: React.ReactNode
  text: React.ReactNode
  media: React.ReactNode

  date?: string

  isUpcoming?: boolean
  isOutdated?: boolean

  isUnread?: boolean
}

export const PortalNewsListItem = React.memo(
  ({
    title,
    portalVersion,
    category,
    text,
    media,
    date,
    className,
    isUpcoming,
    isOutdated,
    isUnread
  }: PortalNewsListItemProps) => {
    const { t } = useTranslation()

    return (
      <li
        className={classNames(
          "portal-news-list-item",
          { upcoming: isUpcoming, outdated: isOutdated },
          className
        )}
        data-testid="portal-news-list-item"
      >
        <div className="portal-news-list-item__date">{date}</div>
        <div className="portal-news-list-item__header">
          <div className="portal-news-list-item__chips">
            <Chip
              className="chip--small portal-news-list-item__upcoming"
              variant={ChipVariant.WARNING}
              icon={IconName.CALENDAR_CLOCK}
            >
              {t("General.Upcoming")}
            </Chip>
            <Chip
              className="chip--small portal-news-list-item__outdated"
              variant={ChipVariant.WARNING}
              icon={IconName.PROJECTS}
            >
              {t("General.Outdated")}
            </Chip>
            <Chip
              isHidden={!category}
              className="chip--small portal-news-list-item__category"
            >
              {category}
            </Chip>
            <Chip className="chip--small portal-news-list-item__portal-version">
              {portalVersion}
            </Chip>
          </div>
          <div
            className={classNames("portal-news-list-item__title", {
              unread: isUnread
            })}
          >
            {title}
          </div>
        </div>
        <div className="portal-news-list-item__media">{media}</div>
        <div className="portal-news-list-item__text">{text}</div>
      </li>
    )
  }
)
